'use strict';

var cov_3sbgz0oxb = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.interactions.factory.js',
        hash = '78c80b9e441fdaf21879f80d461b9b7032370338',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.interactions.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 33,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 62
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 33,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 32,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_3sbgz0oxb.s[0]++;
(function () {
    'use strict';

    cov_3sbgz0oxb.f[0]++;
    cov_3sbgz0oxb.s[1]++;
    angular.module('app').factory('OrganizationInteractionsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_3sbgz0oxb.f[1]++;
        cov_3sbgz0oxb.s[2]++;

        return restmod.model('/organization-interactions').mix('MixinContainable', {
            $config: {
                contains: {
                    tt: {
                        type: 'belongsTo',
                        table: 'InteractionTypesTable',
                        foreignKey: 'interactionType'
                    },
                    email: {
                        type: 'belongsTo',
                        table: 'EmailsTable',
                        foreignKey: 'email'
                    },
                    org: {
                        type: 'belongsTo',
                        table: 'OrganizationsTable',
                        foreignKey: 'organization'

                    }
                }
            }
        });
    }
})();